export default {"src":"/_next/static/media/percentage.3d9b3725.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};